import Debug from 'debug';
import { PracticeStateMachineAbstractState, PracticeStateMachineCommonEvents } from './state'
import { PracticeStateMachineData } from '../data'

const debug = Debug('practice-review-state')

interface Events extends PracticeStateMachineCommonEvents {
  onReviewFinished: () => void
}

export class PracticeReviewState extends PracticeStateMachineAbstractState<Events> {

  public readonly name = 'review'

  constructor(private startAtQuestionIndex: number,
              private state: PracticeStateMachineData) {
    super()
  }

  navigate(questionIndex: number) {
    this.state.updateCurrentQuestion(questionIndex, this.navigationOptions)
  }

  navigateNext() {
      this.state.goToNextQuestion(this.navigationOptions)
  }

  navigatePrevious() {
    this.state.goToPreviousQuestion(this.navigationOptions)
  }

  private get navigationOptions() {
    return { updateLastIndex: false }
  }

  finish() {
    this.triggerEvent(events => events.onReviewFinished())
  }

  enter() {
    debug('enter')
    this.state.review(this.startAtQuestionIndex, { updateLastIndex: false })
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }
}
